const storeKey = "pkzbmerscurcamp";
const setStore = () => {

    localStorage.setItem(
        storeKey, JSON.stringify({
            data: {}
        })
    );
};

const fill = (data) => {
    if(localStorage.getItem(storeKey) == undefined) setStore();
    let store = localStorage.getItem(storeKey);
    store = JSON.parse(store);
    store.data = data;
    localStorage.setItem(storeKey, JSON.stringify(store)); 
};

const fetch = (key) => {
    if(localStorage.getItem(storeKey) == undefined) setStore();
    let store = localStorage.getItem(storeKey);
    store = JSON.parse(store);
    return store['data'][key];
};

const feed = (key, data) => {
    if(localStorage.getItem(storeKey) == undefined) setStore();
    let store = localStorage.getItem(storeKey);
    store['data'][key] = data;
    localStorage.setItem(storeKey, store);
};

export const storeCampaign = {
    fill,
    fetch,
    feed
};